export default __webpack_public_path__ + "static/media/fotter-right.e5347b89.svg";